"use client";

import { CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhatMakesIronPeakDifferent() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: listRef,
    isVisible: listVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const differences = [{
    id: 1,
    text: "Physician-led care: You work directly with a licensed physician—not a sales rep or automated protocol."
  }, {
    id: 2,
    text: "Root-cause focus: We use labs and clinical reasoning to understand why symptoms are happening."
  }, {
    id: 3,
    text: "Physiologic, safety-first approach: Our protocols prioritize long-term health, not aggressive dosing."
  }, {
    id: 4,
    text: "Ongoing follow-up: We don't disappear after the prescription is written."
  }, {
    id: 5,
    text: "Telemedicine across Texas: Care that fits your schedule, without sacrificing quality."
  }];
  return <section className="bg-background py-8 sm:py-8 lg:py-8">
      <div className="container">
        <div ref={headerRef} className={`text-center mb-12 transition-all duration-700 ease-out-back ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground">
            What Makes IronPeak Different
          </h2>
        </div>

        <div ref={listRef} className={`max-w-4xl mx-auto transition-all duration-700 ease-out-back delay-200 ${listVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <ul className="space-y-6">
            {differences.map((item, i) => <li key={item.id} data-index={i} className="flex items-start gap-4 group">
                <div className="shrink-0 mt-1">
                  <CircleCheck className="size-6 text-primary group-hover:text-primary-hover transition-colors duration-300" />
                </div>
                <p className="text-base sm:text-lg text-foreground leading-relaxed group-hover:text-primary transition-colors duration-300">
                  {item.text}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}